import { CampaignStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const campaignStatusMessages = defineMessages({
  active: {
    defaultMessage: 'Active',
    description: 'campaign status name',
  },
  archived: {
    defaultMessage: 'Archived',
    description: 'campaign status name',
  },
  paused: {
    defaultMessage: 'Paused',
    description: 'campaign status name',
  },
})

export function translateCampaignStatus(intl: IntlShape, status: CampaignStatus): string {
  switch (status) {
    case CampaignStatus.ACTIVE:
      return intl.formatMessage(campaignStatusMessages.active)
    case CampaignStatus.ARCHIVED:
      return intl.formatMessage(campaignStatusMessages.archived)
    case CampaignStatus.PAUSED:
      return intl.formatMessage(campaignStatusMessages.paused)
  }
}
